import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

import { Model } from '../../models/vehicle.ops';
import { VehicleMakeModel } from './../../models/vehicle-make';
import { VehicleProvider } from './../../providers/vehicle/vehicle';


@Component({
  selector: 'page-select-vehicle-model',
  templateUrl: 'select-vehicle-model.html',
})
export class SelectVehicleModelPage {
  vehicleMake: VehicleMakeModel;
  models: Model[] = [];
  filteredModels: Model[];
  isModal: boolean;
  query: string;
  selectedModel: Model;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private vehicleService: VehicleProvider,
    private viewCtrl: ViewController
  ) {
    this.isModal = navParams.get('modal');
    this.vehicleMake = navParams.get('make');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectVehicleMakePage');
  }

  ngOnInit() {
    if (this.vehicleMake) {
      this.vehicleService
        .getCarModels(this.vehicleMake.uid)
        .subscribe(models => {
          this.models = models || [];
          this.filteredModels = models;
        });
    }
  }

  filterModels() {
    this.filteredModels = this.models.filter(model => {
      return model.model.toLowerCase().includes(this.query.toLowerCase());
    });
  }

  didSelectModel(model: Model) {
    this.selectedModel = model;
    this.dismiss();
  }

  dismiss() {
    this.isModal
      ? this.viewCtrl.dismiss(this.selectedModel)
      : this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/select-vehicle-model/select-vehicle-model.ts